import { useEffect, useMemo, useState } from 'react';

export const useResizeListener = () => {
  const [width, setWidth] = useState(window.innerWidth);

  const isMobile = useMemo(() => width <= 768, [width]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      const bodyWidth = entries[0].contentRect.width;
      setWidth(bodyWidth);
    });
    resizeObserver.observe(document.body);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return { innerWidth: width, isMobile };
};
